import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import CancelableChip from '../Chips/CancelableChip'
import css from './styles.css'

const containerClasses = cx(css.wrapper, css.filtersContainer)

const MessagesFilterClearBar = ({
  handleClearFilter,
  hasDSO,
  selectedEmailOrText,
  selectedLocationId,
  selectedRadioBtn,
  selectedSearchTerm,
  activeDateFilterString,
}) => {
  const capRadioLabel =
    selectedRadioBtn.charAt(0).toUpperCase() + selectedRadioBtn.slice(1)
  const hasFilters = [
    {
      label: 'Location',
      hasContent: !!selectedLocationId.length && !hasDSO,
      type: 'selectedLocationId',
    },
    {
      label: activeDateFilterString,
      hasContent: !!activeDateFilterString,
      type: 'selectedTimeRange',
    },
    {
      label: 'Search Term',
      hasContent: selectedSearchTerm,
      type: 'selectedSearchTerm',
    },
    {
      label: capRadioLabel,
      hasContent: selectedEmailOrText,
      type: 'selectedEmailOrText',
    },
  ]
  const currentFilters = hasFilters.filter(
    filterType => filterType.hasContent && filterType.label,
  )

  return (
    <div>
      {!!currentFilters.length && (
        <div className={containerClasses}>
          <div className={css.filtersTitle}>Active Filters:</div>
          <div className={css.activeFilterContainer}>
            {currentFilters.map(filter => (
              <CancelableChip
                key={filter.type}
                handleRemoveChip={handleClearFilter}
                id={filter.type}
                title={filter.label}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

MessagesFilterClearBar.propTypes = {
  activeDateFilterString: PropTypes.string.isRequired,
  handleClearFilter: PropTypes.func.isRequired,
  hasDSO: PropTypes.bool.isRequired,
  selectedEmailOrText: PropTypes.bool.isRequired,
  selectedLocationId: PropTypes.string.isRequired,
  selectedRadioBtn: PropTypes.string.isRequired,
  selectedSearchTerm: PropTypes.string.isRequired,
}

export default MessagesFilterClearBar



// WEBPACK FOOTER //
// ./src/components/sitewide/Filter/MessagesFilterClearBar.js